"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNTIME_PROBE_REFUSAL_REASONS = exports.APP_SIF_NAME = exports.APP_IMAGE_ROOT_MAX_LENGTH = exports.APPS_IMAGE_POLICIES = exports.RUNTIME_REFUSAL_REASONS = exports.CONTAINER_RUNTIME_KINDS = exports.MOUNT_CONFLICT_REASONS = exports.DATA_ROOT_REFUSAL_REASONS = void 0;
exports.DATA_ROOT_REFUSAL_REASONS = ["duplicate_root"];
exports.MOUNT_CONFLICT_REASONS = [
    "stale_version",
    "workspace_archived",
    "environment_gone",
];
exports.CONTAINER_RUNTIME_KINDS = [
    "apptainer",
    "singularity",
    "docker",
];
exports.RUNTIME_REFUSAL_REASONS = [
    "docker_on_ssh",
    "local_execution_unavailable",
    "invalid_command",
    "invalid_module",
    "invalid_image",
    "executor_unsupported",
    "no_image",
    "hpc_apps_disabled",
    "invalid_apps_settings",
    "invalid_app_caps",
    "apps_need_agent_environment",
    "apps_node_cidr_required",
    "workspace_jobs_disabled",
    "invalid_workspace_caps",
    "runtime_required",
];
exports.APPS_IMAGE_POLICIES = ["published_apps", "listed"];
exports.APP_IMAGE_ROOT_MAX_LENGTH = 512;
exports.APP_SIF_NAME = /^[A-Za-z0-9._-]+\.sif$/;
exports.RUNTIME_PROBE_REFUSAL_REASONS = [
    "not_ssh",
    "no_runtime",
    "no_image",
    "executor_unsupported",
    "runtime_unsupported_over_ssh",
    "home_unreadable",
    "workspace_base_unresolved",
    "probe_directory_invalid",
    "invalid_queue",
    "workspace_jobs_disabled",
    "hpc_apps_disabled",
    "apps_not_enabled",
    "apps_probe_running",
    "image_not_allowed",
    "invalid_apps_settings",
    "apps_need_agent_environment",
    "agent_not_connected",
    "agent_too_old",
    "agent_not_ready_for_workspace_jobs",
    "apps_probe_owner_only",
];
